module.exports = __webpack_public_path__ + "media/fonts/bootstrap-icons-c1d7432e.woff";